/**
 * @desc 拦截包裹
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.packageIntercept.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/packageIntercept`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
